import { ENTRY_DATA_SECTION_KEYS as SECTION_KEYS } from "@frontend/common/src/constants/entryData";

import { ArticleSectionType } from "@FillInTableContainer/types/fillInTable.types";

import type { ClassificationCode } from "@/types/code.types";

const BASE_ARTICLE_SECTION_BY_CLASSIFICATION: Record<
  string,
  ArticleSectionType | "none"
> = {
  C000: SECTION_KEYS.clinicalTrial,
  C001: SECTION_KEYS.clinicalTrialStatus,
  C003: "none",
  C004: SECTION_KEYS.conferenceSchedule,
  C005: SECTION_KEYS.clinicalTrial,
  C006: "Deals",
  C007: "none",
  C008: SECTION_KEYS.publicationJournal,
  C009: "none",
  C010: "none",
  C011: "none",
  C012: "none",
  C013: SECTION_KEYS.regulatory,
  C201: SECTION_KEYS.regulatoryLabel,
  C202: SECTION_KEYS.regulatoryLabel,
  C014: "none",
  C015: "none",
  C016: SECTION_KEYS.expeditedProgram,
  C017: "none",
  C018: "none",
  C019: "none",
  C020: "none",
  C021: SECTION_KEYS.ventureCapital,
  C022: "none",
  C023: "none",
  C024: "none",
  C025: "none",
  C101: SECTION_KEYS.companyWebsiteVariousPages,
  "": "none",
  P001: SECTION_KEYS.publication,
  P002: SECTION_KEYS.publication,
  P004: SECTION_KEYS.publication,
  P005: SECTION_KEYS.publication,
  P006: SECTION_KEYS.publication,
  P007: SECTION_KEYS.publication,
  P008: SECTION_KEYS.publication,
  P009: SECTION_KEYS.publication,
  P010: SECTION_KEYS.publication,
  P011: SECTION_KEYS.publication,
  P012: SECTION_KEYS.publication,
  P013: SECTION_KEYS.publication,
  P014: SECTION_KEYS.publication,
  P999: SECTION_KEYS.publication,
  C801: SECTION_KEYS.dealFiling,
  C802: SECTION_KEYS.fundingFiling,
  ctg: SECTION_KEYS.ctg,
  regulatoryLabel: SECTION_KEYS.regulatoryLabel,
};

export const ARTICLE_SECTION_BY_CLASSIFICATION: Record<
  ClassificationCode,
  ArticleSectionType | "none"
> = new Proxy(BASE_ARTICLE_SECTION_BY_CLASSIFICATION, {
  get: (target, prop: string) =>
    prop.startsWith("DERA") ? SECTION_KEYS.ctg : Reflect.get(target, prop),
}) as Record<ClassificationCode, ArticleSectionType | "none">;
